import './assets/main.css'

import { createApp } from 'vue'

// Vuetify
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Pinia
import { createPinia } from 'pinia'

// Components
import App from './App.vue'

const app = createApp(App)

app.use(
  createVuetify({
    components,
    directives,
  }),
)

app.use(createPinia())

app.mount('#jellybeans-admin-ui')
